export { default } from './EventListPage'



// WEBPACK FOOTER //
// ./src/App/EventListPage/index.js